import { useShiftClick } from "hooks/useShiftClick";
import React from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { toggleSelectedItem } from "reducers/Selected";

import "./VersionName.css";

const EVENT_RIGHT_CLICK_PRESS = 2;
const selectVersions = state => state.creativeVersions.items;

export default function VersionName({ value, dependentValues }){
	const { versionId, type, isSelected } = dependentValues
		, urlParams = useParams()
		, dispatch = useDispatch()
		, { libraryId, creativeId } = urlParams
		;

	const shiftClick = useShiftClick(versionId, type, { selectItems: selectVersions });
	const handleClick = (event) => {
		// Prevent selection with right click
		if (event.button === EVENT_RIGHT_CLICK_PRESS) {
			return;
		}

		if (event.nativeEvent.shiftKey) {
			shiftClick(event);
			return;
		}
		dispatch(toggleSelectedItem(versionId, type, !isSelected));
	};

	return(
		<div className="version-name-col name-overflow" title={value} onMouseDown={handleClick}>
			<Link to={`/library/${libraryId}/creative/${creativeId}/versions/${versionId}/modal/preview-version/`}>
				{value}
			</Link>
		</div>
	);
}

VersionName.displayName = "VersionName";
VersionName.defaultProps = {
	value:null,
	dependentValues:{},

};
